
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function SettingsTab() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Account Settings</CardTitle>
        <CardDescription>Manage your account preferences</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="mb-4">Update your account settings and preferences.</p>
        <Button variant="outline" className="w-full" disabled>
          Coming Soon
        </Button>
      </CardContent>
    </Card>
  );
}
